'use client';
import Typography from '@/components/shared/typography/typography.component';
import Image from 'next/image';
import { CSSProperties } from 'react';

const ButtonWithIcon = ({
    text,
    active,
    buttonClicked,
    img,
    imgActive,
    style,
    extraClassNames = '',
    innerExtraClassNames = '',
}: {
    text: string;
    active: boolean;
    buttonClicked: () => void;
    img: any;
    imgActive: any;
    style?: CSSProperties;
    extraClassNames: string;
    innerExtraClassNames: string;
}) => {
    const iconSource = active ? imgActive : img;
    return (
        <button
            onClick={() => buttonClicked()}
            className={`cursor-pointer px-3.5 py-2 rounded-lg border-solid border border-gray-300 ${
                extraClassNames ? extraClassNames : ''
            } ${
                active
                    ? ' border-solid border-primary-600 bg-primary-600 text-white'
                    : ''
            }`}
            style={{ ...style }}
        >
            <div
                className={`flex items-center justify-between w-max gap-2  ${
                    innerExtraClassNames ? innerExtraClassNames : ''
                }`}
            >
                <Image
                    width={16}
                    height={16}
                    src={iconSource}
                    alt="Button icon"
                />
                <Typography
                    component={'p'}
                    className={`text-sm w-max font-semibold  whitespace-nowrap ${
                        active ? ' text-white' : ' text-gray-700'
                    }`}
                >
                    {text}
                </Typography>
            </div>
        </button>
    );
};

export default ButtonWithIcon;
